export const conversationalTags = "/:app_group_id/conversational/tags";
